import React from 'react';

import styles from './ThreeParts.module.less';
import AutoPageTurn from '../AutoPageTurn';
import GameLink from '../GameLink';
import Icon from '../Icon';
import Button from '../Button';
import useLog from '../../hooks/useLog';

export default ({ title, operate, to, tag: source, data = [] }) => {
  const [report] = useLog();

  return (
    <AutoPageTurn
      size={data.length}
      title={title}
      operate={operate}
      to={to}
      source={source}>
      <nav className={styles.ThreeParts}>
        {
          data
            .map((app, index) => {
              let id = app.softID || ''
              if (app.androidType === '1') {
                id = app.packageName
              }

              return (
                <GameLink
                  key={index}
                  info={{
                    targetType: '1',
                    appInfo: app,
                  }}
                  source={source}
                  logInfo={{
                    category: 'C',
                    action: 'Game_Non_Button',
                    params: {
                      id,
                      type: 'soft',
                      source,
                    },
                    bizInfo: app.bizInfo,
                  }}
                  onMouseEnter={() => {
                    if (!app.resUrl)  return

                    report('C', 'Hover_Video', {
                      softid: id,
                      softtype: app.androidType === '1' ? '1' : '0',
                      source
                    });
                  }}>
                  <header className={app.resUrl ? '' : 'anim'}>
                    <b style={{backgroundImage: `url("${app.ztImg}")`}}></b>
                    {app.resUrl && <b style={{ backgroundImage: `url("${app.resUrl}")` }}></b>}
                    {app.resUrl && <i></i>}
                  </header>
                  <section>
                    <Icon className="icon" app={app} />
                    <h1 title={app.softName}>{app.softName}</h1>
                    <p>{app.introduction}</p>
                    <Button
                      soft={app}
                      className="action btn"
                      logInfo={{source}} />
                  </section>
                </GameLink>
              )
            })
        }
      </nav>
    </AutoPageTurn>
  );
};
